import axios from "axios";
import config from "./api.json"
const Gearz=axios.create({
    baseURL:config.base_url
})

export default Gearz